import styled from 'react-emotion'

const SPOTIFY_BRAND = '#1db954'

export const Button = styled.button`
  padding: 14px 28px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  background: ${SPOTIFY_BRAND};
  border-radius: 32px;
  font-weight: 700;
  font-size: 14px;
  color: white;
  display: inline-block;
  width: 250px;
`
export const ButtonAsLink = Button.withComponent('a')



// WEBPACK FOOTER //
// ./src/components/Button.js